import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import { getUserMenuList } from '@/api/menu'
import Placeholder from '@/views/Placeholder.vue'
import CaseEdit from '@/views/CaseEdit.vue'
import DocumentEdit from '@/views/DocumentEdit.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/case/edit/:caseId?',
    name: 'CaseEdit',
    component: CaseEdit,
    meta: { title: '案件编辑', requiresAuth: true }
  },
  {
    path: '/document/edit/:documentId/:caseId?',
    name: 'DocumentEdit',
    component: DocumentEdit,
    meta: { title: '文书编辑', requiresAuth: true }
  },
  {
    path: '/bookmark-manage/:templateId/:templateName?',
    name: 'BookmarkManage',
    component: () => import('@/views/BookmarkManage.vue'),
    meta: { title: '书签维护', requiresAuth: true }
  },
  {
    path: '/confirm-attendance-sign',
    name: 'ConfirmAttendanceSign',
    component: () => import('@/views/ConfirmAttendanceSign.vue'),
    meta: { title: '确认参会签名', requiresAuth: false }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true },
  }
]

const router = new VueRouter({
  routes
})

let hasLoadedRoutes = false

/** page_route 与库一致（如 MyCase），组件文件自动补 .vue */
function resolveMenuRoute(menu) {
  const raw = (menu.pageRoute || '').trim().replace(/^\//, '').replace(/\.vue$/i, '')
  return {
    routePath: `/${raw}`,
    vueFile: `${raw}.vue`,
  }
}

async function loadDynamicRoutes() {
  try {
    const res = await getUserMenuList()
    if (res.code === 200) {
      const menus = res.data || []
      const seenPaths = new Set()

      menus.forEach(menu => {
        if (!menu.pageRoute || menu.pageRoute.trim() === '') {
          return
        }
        const { routePath, vueFile } = resolveMenuRoute(menu)
        if (seenPaths.has(routePath)) {
          return
        }
        seenPaths.add(routePath)

        if (!router.getRoutes().find(r => r.path === routePath)) {
          router.addRoute('Home', {
            path: routePath,
            name: `menu-${menu.menuId}`,
            component: () => import(`@/views/${vueFile}`),
            meta: {
              title: menu.menuName,
              requiresAuth: true
            }
          })
        }
      })

      hasLoadedRoutes = true
      return true
    }
    return false
  } catch (error) {
    console.error('加载动态路由失败:', error)
    return false
  }
}

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || '系统'

  const token = localStorage.getItem('token')

  if (to.path === '/login') {
    next()
    return
  }

  if (to.meta && to.meta.requiresAuth === false) {
    next()
    return
  }

  if (!token) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }

  if (!hasLoadedRoutes) {
    try {
      await loadDynamicRoutes()
      next({ ...to, replace: true })
      return
    } catch (error) {
      console.error('加载路由失败:', error)
      next('/login')
      return
    }
  }

  next()
})

export default router
